export default __webpack_public_path__ + "static/media/pollo_loco.5d19e1ff.png";